var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.210938.210938h17.578162v17.578162h-17.578162zm16.140662 13.386762c-.1289-.8047-.6524-1.4766-2.1993-2.1055-.539-.25-1.1406-.4297-1.3164-.836-.0664-.2421-.0781-.371-.0351-.5156.1133-.47654.668-.61716 1.1094-.48435.2851.08984.5507.30469.7148.65625.7578-.49609.7578-.49609 1.2852-.82422-.1954-.30469-.293-.4414-.4297-.57031-.461-.51953-1.0743-.78125-2.0743-.75781l-.5195.0664c-.4961.1211-.9687.38282-1.2539.73438-.832.94531-.5937 2.59376.418 3.27736 1 .7461 2.4609.9101 2.6484 1.6133.1758.8593-.6367 1.1328-1.4414 1.0312-.5937-.1328-.9219-.4297-1.2851-.9766l-1.3399.7696c.1524.3515.3281.5039.5938.8125 1.2734 1.2851 4.4609 1.2187 5.0312-.7344.0195-.0664.1758-.5195.0547-1.207zm-6.58207-5.30864h-1.64453c0 1.41797-.00781 2.82814-.00781 4.25004 0 .9023.04687 1.7304-.10157 1.9843-.24218.5039-.86328.4414-1.14843.3516-.28907-.1445-.4375-.3398-.60547-.625-.05078-.0781-.08203-.1445-.09375-.1445l-1.33594.8242c.22266.4609.55078.8594.96875 1.1094.625.375 1.46875.4961 2.34766.2968.57422-.164 1.0664-.5078 1.32422-1.0312.375-.6797.29296-1.5156.29296-2.4531.00782-1.5039 0-3.00785 0-4.52738z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJsIcon);
export default __webpack_public_path__ + "static/media/js-icon.5d45e35929fcc38bb464baa0beabcdd3.svg";
export { ForwardRef as ReactComponent };